import { prefix } from '@/configs/testAutomation';

const constructedIds = {
  retreatBtn: '',
  rejectRequestBtn: '',
  startServiceBtn: '',
  backToNajizDataBtn: '',
  cancelRequestBtn: '',
  requestAdditionalDataBtn: '',
  home: {
    intro: {
      additionalDataBtn: '',
      openDataPolicyBtn: '',
    },
    openData: {
      card: '',
      showDataBtn: '',
    },
    faqs: {
      questionsWrapper: '',
      questionHeader: '',
    },
  },
  openData: {
    card: '',
  },
  additionalDataRequest: {
    email: '',
    mobile: '',
    submit: '',
    socialId: '',
    agreement: '',
    verifyBtn: '',
    description: '',
    requestType: '',
    nextStepBtn: '',
    prevStepBtn: '',
    backToVerifyBtn: '',
    startServiceBtn: '',
    editApplicantInfoBtn: '',
    editRequestDetailsBtn: '',
    validateApplicantToaster: '',
    organizationNationalNumber: '',
    activateBussinessAccountBtn: '',
    applicantVerificationSection: '',
    toasterSuccessMessage: '',
  },
  toaster: {
    error: '',
    success: '',
  },
};

function generateIds(obj: any, parentNodes: string[] = []) {
  const mutatedIds: any = {};

  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === 'object') {
      const nodes = [...parentNodes, key];
      mutatedIds[key] = { ...generateIds(obj[key], nodes) };
    } else {
      mutatedIds[key] = !parentNodes.length ? `${prefix}_${key}` : `${prefix}_${parentNodes.join('_')}_${key}`;
    }
  });

  return mutatedIds;
}

export const testIds = generateIds(constructedIds);
